

(function($, window, document) {

	// The $ is now locally scoped 
    
    if(typeof Number.prototype.pad2 !== "function"){
        Number.prototype.pad2 = function(){
            return 10>this?"0"+this:""+this
        }
    } 

    if (!String.prototype.trim) {
        String.prototype.trim = function () {
            return this.replace(/^[\s\uFEFF\xA0]+|[\s\uFEFF\xA0]+$/g, '');
        };
    }

	


    function is_ie() {

        var ua = window.navigator.userAgent;
        var msie = ua.indexOf("MSIE ");

        if (msie > 0 || !!navigator.userAgent.match(/Trident.*rv\:11\./))  // If Internet Explorer, return version number
        {
            return true;
        }
        else  // If another browser, return 0
        {
            return false;
        }

        return false;
    }


    function is_mozilla() {

        if(navigator.userAgent.toLowerCase().indexOf('firefox') > -1){
            return true;
        }

        return false;
    }




    function isJson(str) {
        try {
            JSON.parse(str);
        } catch (e) {
            return false;
        }
        return true;
    }

    function strInsert(main_string, ins_string, pos) {
        if(typeof(pos) == "undefined" || typeof(ins_string) == "undefined" || main_string.length <= pos) {
            return main_string
        } 

        return main_string.slice(0, main_string.length - pos) + ins_string + main_string.slice( main_string.length - pos);
    }



    //  COOKIES

    function createCookie(name, value, days) {
        if(days) {
          var date = new Date();
          date.setTime(date.getTime() + (days * 24 * 60 * 60 * 1000));
          var expires = "; expires=" + date.toGMTString();
        } else var expires = "";
        document.cookie = name + "=" + value + expires + "; path=/"
    }

    function readCookie(name) {
        var nameEQ = name + "=";
        var ca = document.cookie.split(';');
        for (var i = 0; i < ca.length; i++) {
            var c = ca[i];
            while (c.charAt(0) == ' ') c = c.substring(1, c.length);
            if (c.indexOf(nameEQ) == 0) return c.substring(nameEQ.length, c.length);
         
        }
        return null;
    }

    function eraseCookie(name) {
        createCookie(name, "", -1);
    }





    function update_header_sizes(l = 0) {

        $('.nhm-header-container').removeClass('-header-small');
        setTimeout(function(){
            
            if(($('.nhm-header-container').innerWidth() * 0.96) < ($('.nhm-header-container').find('> .nhm-header-brand').innerWidth() + $('.nhm-header-container').find('> .nhm-header-nav').innerWidth())){
                $('.nhm-header-container').addClass('-header-small');
            }
        },100);
        
        let resize_time = 300;
        if(l == -2){
            resize_time = 0;
        }
        setTimeout(function(){
            let window_sc_top = $(window).scrollTop();
            if(window_sc_top < 3 || l == -1){
                $(".nhm-add-header-size").css({
                    'padding-top': ($('header.nhm-header-section').innerHeight() )+'px',
                });
            }else if(l < 10){
                // console.log(l)

                // setTimeout(function(){
                //     update_header_sizes(l + 1)
                // },200);
            }
        },resize_time);

    }

    update_header_sizes(-2)




    var target = window.location.search;
    var hasSearch = ((target[0] == '?') || (window.location.href[window.location.href.length - 1] == '?'));

    target = target.replace('?', '');


    var targets = target.split("&");
    for(var i = 0; i < targets.length; i++){
        // if(targets[i].split("=")[0] == "solucao_id"){
            

        //     window.history.pushState(null, null, window.location.href.replace(window.location.search, "")); 
        // }
    }



    var vars_GET = window.location.search.slice(1).split('&').reduce(function _reduce (/*Object*/ a, /*String*/ b) {
                                                                        b = b.split('=');
                                                                        a[b[0]] = decodeURIComponent(b[1]);
                                                                        return a;
                                                                    }, {}
                                                                );
    if(vars_GET.login && vars_GET.message){
        // $('#nhm-login-modal').modal('show')
        // window.history.pushState(null, null, window.location.href.replace(window.location.search, "")); 
    }else if (vars_GET.open_login) {
        // $('#nhm-login-modal').modal('show')
        
    }

    
    var location_href = $(location).attr('href');
    if (location_href.indexOf("#") >= 0) {

        var scrTop = ($('#'+(location_href.split('#')[1])).offset().top - (parseInt($('body').css('padding-top')) + parseInt($('html').css('margin-top'))) );
        var root = $('html, body');

        root.animate({scrollTop: scrTop}, 600);

    }



    /*Anchor scroll*/
    $('a[href*="#"]').click(function(e) {
        var link = this.href;
        
        if (link.indexOf("#") >= 0) {
            var location_href = $(location).attr('href');

            if(location_href.split('#')[0] == link.split('#')[0]){
                e.preventDefault();

                var scrTop = ($('#'+(link.split('#')[1])).offset().top - (parseInt($('body').css('padding-top')) + parseInt($('html').css('margin-top')) ) );
                var root = $('html, body');

                root.animate({scrollTop: scrTop}, 400);
            }

        }

    });




    // function increment_numbers(el,value, before = '', after = "", time = 1000){
    function increment_numbers(el,value, before, after, time){

        if(el.increment_numbers_started != true){
            el.increment_numbers_started = true;
            if(el.current){}else{
                el.current = parseInt(el.innerText.replace(/\D/g, ""));
            }

            if(value < (time / 50)){
                let interval_time = time / value;
                let interval = setInterval(function(){
                    if(el.current == value){
                        clearInterval(interval);
                    }else{
                        el.current++;
                        if(el.current > value){
                            el.current = value;
                        }
                        el.innerHTML = before+'<span>'+parseInt(el.current)+'</span>'+after;
                    }
                },interval_time);
            }else{

                let interval_time = 50;
                let increment_value = value / (time / interval_time);
                let interval = setInterval(function(){
                    if(el.current == value){
                        clearInterval(interval);
                    }else{
                        el.current = el.current + increment_value;
                        if(el.current > value){
                            el.current = value;
                        }
                        el.innerHTML = before+'<span>'+parseInt(el.current)+'</span>'+after;
                    }
                },interval_time);

            }
        }
    }



	$(window).scroll(function(event) {
        let window_sc_top = $(window).scrollTop();
        let window_i_height = window.innerHeight;

		if(window_sc_top > 5){
			$('body').addClass('no-top');
		}else{
			$('body').removeClass('no-top');
            update_header_sizes();
		}

        if(window_sc_top > ($(window).innerHeight() / 6)){
            $('body').addClass('scrolled');
        }else{
            $('body').removeClass('scrolled');
            setTimeout(function(){
                // update_header_sizes();
            },200);
        }

        $(".nhm-counters").each(function(index, el) {
            if($(el).offset().top < (window_sc_top + (window_i_height * 0.7))){
                $(el).find('.counters-item').each(function(index, el_item) {
                    let num_el = $(el_item).find('.num');
                    if(num_el.length > 0){

                        increment_numbers(
                                            num_el[0],
                                            $(el_item).data('value'),
                                            $(el_item).data('before'),
                                            $(el_item).data('after'),
                                            $(el).data('time')
                                        );
                    }
                });
            }
        });
        
	});



	$('.nhm-header-menu-button').click(function(event) {
		if($(this).hasClass('active')){
			$(this).removeClass('active');
			$('.nhm-header-menu-close').removeClass('active');
			$('.nhm-header-nav').removeClass('active');
			$(this).find('svg').removeClass('active');
			$('body').removeClass('menu-open');
		}else{

			$(this).addClass('active');
			$('.nhm-header-menu-close').addClass('active');
			$('.nhm-header-nav').addClass('active');
			$(this).find('svg').addClass('active');
			$('body').addClass('menu-open');
		}
	});



	$('.nhm-header-menu-close, .nhm-header-menu-btn-close').click(function(event) {
		$('.nhm-header-menu-close').removeClass('active');
		$('.nhm-header-menu-button').removeClass('active');
		$('.nhm-header-nav').removeClass('active');
		$('.nhm-header-menu-button svg').removeClass('active');
		$('body').removeClass('menu-open');
	});




	window.addEventListener('resize', function(event){

        if($('header.nhm-header-section').length > 0){
            setTimeout(function(){
                // $("body").css({
                //     'padding-top': ($('header.nhm-header-section').innerHeight() )+'px',
                // });
                update_header_sizes(-1);

                // $(".nhm-highlight-home-section").css({
                //     'padding-top': $('header.nhm-header-section').innerHeight()+'px',
                // });
            },500);
        }


        

        

		if($(window).innerWidth() > 990){


            $('.nhm-header-menu-close').removeClass('active');
            $('.nhm-header-menu-button').removeClass('active');
            $('.nhm-header-nav').removeClass('active');
            $('.nhm-header-menu-button svg').removeClass('active');
            $('body').removeClass('menu-open');
		}else{

        }



        if($(window).innerWidth() > 767){

        }else{

          

        }
		
	});

    if($('header.nhm-header-section').length > 0){
        setTimeout(function(){

            update_header_sizes(-1);

        },500);
    }



    if($(window).innerWidth() > 767){

       
    }else{


    }

    



    $(document).click(function(event) { 
        var target = $(event.target);
        if(($(target).parents('.nhm-input-label.open').length < 1)){
            setTimeout(function(){
                $('.select.open').removeClass('open');
            },5);
        }

    });



	//Function  Mask
    function mask(o, f) {
        setTimeout(function () {
            var v = f(o.value);
            if (v != o.value) {
                o.value = v;
            }
        }, 1);
    }

    function mphone(v) {
        v = v.replace(/\D/g, "");
        v = v.replace(/^(\d{2})(\d)/g, "($1) $2");
        v = v.replace(/(\d)(\d{4})$/, "$1-$2");
        return v;
    }

    function mcep(v) {
        v = v.replace(/\D/g, "");
        v = v.replace(/^(\d{5})(\d{3})?/, "$1-$2");
        if(v[v.length - 1] == '-'){
            v = v.slice(0, v.length - 1);
        }   
        return v;
    }

    function mvalue(v) {
        
            v = v.replace(/\D/g, "");
            // v = parseInt(v);
            var position = 6;
            if(parseInt(v) > 0){
                v = String(v);
                while(v.length < 3){
                    v = '0'+v;
                }
                while(v.length > 3 && v[0] == '0'){
                    v = v.slice(1,v.length);
                }

                v = v.slice(0, v.length - 2)+','+v.slice(v.length - 2,v.length);
                while(position < v.length){
                    v = v.slice(0, v.length - position)+'.'+v.slice(v.length - position,v.length);
                    position = position + 4;
                }
            }else{
                v='';
            }
            return v;
    }

    function mnum(v) {
        v = v.replace(/\D/g, "");
        return v;
    }

    function memail(v) {
        v = v.replace(/[()+=#%!{}\[\];:,<>?/\|""''&*°\\/´`~^$¨]/g, "");
        var parts = v.split('@');
        v = "";
        for(var i = 0; i < parts.length; i++){
            if(i == 1){
                v += "@";
            }
            v += parts[i];
        }
        
        return v;
    }


    function mCNPJ(v) {
        v = v.replace(/\D/g, "");
        v = v.replace(/^(\d{2})(\d{3})?(\d{3})?(\d{4})?(\d{2})?/, "$1.$2.$3/$4-$5");
        while(v[v.length - 1] == '-' || v[v.length - 1] == '/' || v[v.length - 1] == '.'){
            v = v.substring(0, v.length - 1);
        }
        return v;
    }

    function mCPF(v) {
        v = v.replace(/\D/g, "");
        v = v.replace(/^(\d{3})(\d{3})?(\d{3})?(\d{2})?/, "$1.$2.$3-$4");
        while(v[v.length - 1] == '-' || v[v.length - 1] == '/' || v[v.length - 1] == '.'){
            v = v.substring(0, v.length - 1);
        }
        return v;
    }

    function mRG(v) {
        v = v.replace(/\D/g, "");
        v = v.replace(/^(\d{2})(\d{3})?(\d{3})?(\d{2})?/, "$1.$2.$3-$4");
        
        return v;
    }

    function mtext(v) {
        v = v.replace(/[0123456789()_+-=#@%!{}\[\];:,<>?/\|""''&*°\\/´`~^$¨]/g, "");
        return v;
    }

    $('input[type="tel"],.mask-tel').keypress(function() {
        mask(this, mphone);
    });

    $('input[type="email"],.mask-email').keypress(function() {
        mask(this, memail);
    });


    $('input.mask-cep').keypress(function() {
        mask(this, mcep);
    });

    $('input.mask-value').keypress(function() {
        mask(this, mvalue);
    });

    $('input.mask-num').keypress(function() {
        mask(this, mnum);
    });

    $('input.mask-text').keypress(function() {
        mask(this, mtext);
    });

    $('input.mask-cpf').keypress(function() {
        mask(this, mCPF);
    });

    $('input.mask-cnpj').keypress(function() {
        mask(this, mCNPJ);
    });


    $('input[type="tel"],.mask-tel').change(function() {
        mask(this, mphone);
    });

    $('input[type="email"],.mask-email').change(function() {
        mask(this, memail);
    });


    $('input.mask-cep').change(function() {
        mask(this, mcep);
    });

    $('input.mask-value').change(function() {
        mask(this, mvalue);
    });

    $('input.mask-num').change(function() {
        mask(this, mnum);
    });

    $('input.mask-text').change(function() {
        mask(this, mtext);
    });

    $('input.mask-cpf').change(function() {
        mask(this, mCPF);
    });

    $('input.mask-cnpj').change(function() {
        mask(this, mCNPJ);
    });



    $('input[type="tel"],.mask-tel').keyup(function() {
        mask(this, mphone);
    });

    $('input[type="email"],.mask-email').keyup(function() {
        mask(this, memail);
    });


    $('input.mask-cep').keyup(function() {
        mask(this, mcep);
    });

    $('input.mask-value').keyup(function() {
        mask(this, mvalue);
    });

    $('input.mask-num').keyup(function() {
        mask(this, mnum);
    });

    $('input.mask-text').keyup(function() {
        mask(this, mtext);
    });

    $('input.mask-cpf').keyup(function() {
        mask(this, mCPF);
    });

    $('input.mask-cnpj').keyup(function() {
        mask(this, mCNPJ);
    });


    $(".mask-cpf-cnpj").keydown(function(event){
        if(event.keyCode == 8){

            var v = this.value.trim();
            v = v.replace(/\./g, '');
            v = v.replace('-', '');
            v = v.replace('/', ''); 
            v = v.replace('.', ''); 

            if(v.length < 13){

                mask(this, mCPF);
            }else{

                mask(this, mCNPJ);
            }
        }

    });


    $(".mask-cpf-cnpj").keypress(function(){

        var v = this.value.trim();
        v = v.replace(/\./g, '');
        v = v.replace('-', '');
        v = v.replace('/', ''); 
        v = v.replace('.', ''); 

        if(v.length < 11){

            mask(this, mCPF);
        }else{

            mask(this, mCNPJ);
        }

    });


    $(".mask-cpf-cnpj").change(function(event ){


        var v = this.value.trim();
        v = v.replace(/\./g, '');
        v = v.replace('-', '');
        v = v.replace('/', ''); 
        v = v.replace('.', ''); 


        if(v.length < 12){

            mask(this, mCPF);
        }else{

            mask(this, mCNPJ);
        }
        

    });


    $(".mask-cpf-cnpj").each(function(index, el){
        var v = this.value.trim();
        v = v.replace(/\./g, '');
        v = v.replace('-', '');
        v = v.replace('/', ''); 
        v = v.split('');

        if(v.length < 12){

            mask(el, mCPF);
        }else{

            mask(el, mCNPJ);
        }
    });


    $('input.mask-cpf').each(function(index, el){
        mask(el, mCPF);
    });
    $('input.mask-cnpj').each(function(index, el){
        mask(el, mCNPJ);
        
    });
    $('input[type="tel"],.mask-tel').each(function(index, el) {
        mask(el, mphone);
    });
    $('input.mask-cep').each(function(index, el) {
        mask(el, mcep);
    });






    // Set recaptcha token to input
    if(typeof grecaptcha !== 'undefined') {
        var last_recaptcha_time = (new Date).getTime();
        grecaptcha.ready(function() {
            grecaptcha.execute(wpcf7_recaptcha.sitekey, {action: 'submit'}).then(function(token) {
                var i = $('input.nhm-g-recaptcha-t');
    
                if(i.val() == '') i.val(token);
            });
        });

        $('html, input, select, textarea').on('change keyup blur click focus hover keypress keydown',function(event) {
            let new_recaptcha_time = (new Date).getTime();
            if(new_recaptcha_time - last_recaptcha_time > (1000*60*2)){
                last_recaptcha_time = new_recaptcha_time;

                grecaptcha.execute(wpcf7_recaptcha.sitekey, {action: 'submit'}).then(function(token) {
                    var i = $('input.nhm-g-recaptcha-t');
        
                    i.val(token);
                    // console.log('reCa_update');
                });
            }
        });
    }



    $("form:not(.no-validate) select:not(.no-validate)").each(function(index, el) {
        var option = $(el).find('option')[0];
        if(option){
            if(option.value == '' || $(el).hasClass('select-first-empty')){
                option.value = '';
                $(option).attr({
                    disabled: 'true',
                    selectec: 'true'
                });
            } 

        }

        $(this).change(function(event) {
            $(this).addClass('changed');
        });
    });


    $("form:not(.no-validate)").submit(function(event) {

        let is_cf7 = $(this).hasClass('wpcf7-form');

        if(is_cf7){

            $(this).find('input[type=submit]').attr({ disabled: '' });
            $(this).addClass('loading');
        }

        var inputs = $(this).find('input:not(.no-validate)');
        var textareas = $(this).find('textarea:not(.no-validate)');
        var selects = $(this).find('select:not(.no-validate)');

        // console.log(inputs);

        var error = false;

        inputs.each(function(index, el) {

            if($(el).parents('.form-change-password').length < 1 || $(el).parents('.form-change-password').find('.change-password').is(':checked')){

                if($(el).parents('.nhm-password-check').length > 0 ){
                    
                    let regex = /^(?=(?:.*?[A-Z]){0})(?=(?:.*?[0-9]){1})(?=(?:.*?[!@#$%*()_+^&}{:;?.]){0})(?!.*\s)[0-9a-zA-Z!@#$%;*(){}_+^&]*$/; 

                    if(el.value == "" || el.value == null ){
                        $(el).addClass('nhm-form-error');
                        $(el).parents('.nhm-input-label').addClass('nhm-form-error');
                        if(!is_cf7){
                            $(el).parents('.nhm-input-label').find('.nhm-error .error-text').html('Esse campo é obrigatório');
                        }
                        error = true
                    }else{
                        if($(el).hasClass('new-password') ){
                            if(el.value.length < 8){
                                $(el).addClass('nhm-form-error');
                                $(el).parents('.nhm-input-label').addClass('nhm-form-error');
                                $(el).parents('.nhm-input-label').find('.nhm-error .error-text').html('A senha deve conter no minímo 8 digitos!');
                                error = true;
                            }else if(el.value.replace(/\D/g, "").length == 0 || el.value.replace(/\D/g, "").length == el.value.length){
                                $(el).addClass('nhm-form-error');
                                $(el).parents('.nhm-input-label').addClass('nhm-form-error');
                                $(el).parents('.nhm-input-label').find('.nhm-error .error-text').html('A senha deve conter no mínimo 1 número e 1 letra');
                                error = true;

                            }
                        }else if($(el).hasClass('verify-password')){

                            if(el.value != $(el).parents('.nhm-password-check').find('.new-password').val()){
                                $(el).addClass('nhm-form-error');
                                $(el).parents('.nhm-input-label').addClass('nhm-form-error');
                                $(el).parents('.nhm-input-label').find('.nhm-error .error-text').html('Esse campo deve ser igual a nova senha');
                                error = true;

                            }
                        }
                    }


                }else if(el.type == 'checkbox'){
                    if($(el).hasClass('required') && $(el).parents('form').find('input[name="'+el.name+'"]:checked').length < 1){
                        $(el).addClass('nhm-form-error');
                        $(el).parents('.nhm-input-label').addClass('nhm-form-error');
                        if(!is_cf7){
                            $(el).parents('.nhm-input-label').find('.nhm-error .error-text').html('Esse campo é obrigatório');
                        }
                        error = true;
                    }
                }else{
                    if(el.value == "" || el.value == null ){
                        $(el).addClass('nhm-form-error');
                        $(el).parents('.nhm-input-label').addClass('nhm-form-error');
                        if(!is_cf7){
                            $(el).parents('.nhm-input-label').find('.nhm-error .error-text').html('Esse campo é obrigatório');
                        }
                        error = true;
                    }
                }
            }else{
                $(el).removeClass('nhm-form-error');
                $(el).parents('.nhm-input-label').removeClass('nhm-form-error');
                if(!is_cf7){
                    $(el).parents('.nhm-input-label').find('.nhm-error .error-text').html('');
                }
            }
        });

        textareas.each(function(index, el) {
            if(el.value == "" || el.value == null ){
                $(el).addClass('nhm-form-error');
                $(el).parents('.nhm-input-label').addClass('nhm-form-error');
                if(!is_cf7){
                    $(el).parents('.nhm-input-label').find('.nhm-error .error-text').html('Esse campo é obrigatório');
                }
                error = true
            }
        });

        selects.each(function(index, el) {
            if(el.value == "" || el.value == null || el.value == "Assunto" || el.value == "Cidade" ){
                $(el).addClass('nhm-form-error');
                $(el).parents('.nhm-input-label').addClass('nhm-form-error');
                if(!is_cf7){
                    $(el).parents('.nhm-input-label').find('.nhm-error .error-text').html('Esse campo é obrigatório');
                }
                error = true
            }
        });




        if(error){
            event.preventDefault();
        }
    });



    $("form").each(function(event) {
        var inputs = $(this).find('input');
        var textareas = $(this).find('textarea');
        var selects = $(this).find('select');

        

        inputs.each(function(index, el) {
            $(el).change(function(event) {
                if(el.value != "" && el.value != null ){
                    $(el).removeClass('nhm-form-error');
                    $(el).removeClass('wpcf7-not-valid');
                    $(el).parents('.nhm-input-label').removeClass('nhm-form-error');
                    $(el).parents('.bp-input-label').find('.bp-error').html('');
                    $(el).parent().find('.wpcf7-not-valid-tip').remove();
                    // console.log($(el).parent().find('.wpcf7-not-valid-tip'));
                }
            });
            
        });

        textareas.each(function(index, el) {
            $(el).change(function(event) {
                if(el.value != "" && el.value != null ){
                    $(el).removeClass('nhm-form-error');
                    $(el).removeClass('wpcf7-not-valid');
                    $(el).parents('.nhm-input-label').removeClass('nhm-form-error');
                    $(el).parents('.bp-input-label').find('.bp-error').html('');
                    $(el).parent().find('.wpcf7-not-valid-tip').remove();
                }
            });
        });

        selects.each(function(index, el) {
            $(el).change(function(event) {
                if(el.value != "" && el.value != null && el.value != "UF" && el.value != "Cidade" ){
                    $(el).removeClass('nhm-form-error');
                    $(el).removeClass('wpcf7-not-valid');
                    $(el).parents('.nhm-input-label').removeClass('nhm-form-error');
                    $(el).parents('.bp-input-label').find('.bp-error').html('');
                    $(el).parents('.nhm-input-label-container').find('.wpcf7-not-valid-tip').remove();
                }
            });
        });


    });


    // $("form.course-filter-form").each(function(index, el) {
    //     let form = $(el);
    //     form.find('input').change(function(event) {
    //         form.submit();
    //     });
    // });





    $("form.wpcf7-form").submit(function(event) {
        $(this).find('input[type=submit]').attr({ disabled: '' });
        $(this).addClass('loading');
    });


    //Function to redirect form after submit
    document.addEventListener( 'wpcf7mailsent', function( event ) {
        var link = $(event.srcElement).parents('[data-thanks-link]').data('thanks-link');

        $(event.srcElement).find('[type=submit]').addClass('successful');
        $(event.srcElement).find('[type=submit]').prop("disabled",false);

        setTimeout(function(){
            $(event.srcElement).find('[type=submit]').removeClass('successful');
        },10000);
        if(link){
            // setTimeout(function(){
            //     location = link;
            // },5000);
            location = link;
        }

    }, false );
    //End
    
    
    

    //libera botão de submit
    document.addEventListener( 'wpcf7invalid', function( event ) {
        $(event.srcElement).find('[type=submit]').prop("disabled",false);
        $('.nhm-input-label .wpcf7-not-valid').each(function(index, el) {
            $(el).parents('.nhm-input-label').addClass('nhm-form-error')
        });
    }, false );
    

    //libera botão de submit
    document.addEventListener( 'wpcf7spam', function( event ) {
        $(event.srcElement).find('[type=submit]').prop("disabled",false);
        $('.nhm-input-label .wpcf7-not-valid').each(function(index, el) {
            $(el).parents('.nhm-input-label').addClass('nhm-form-error')
        });
    }, false );
    

    //libera botão de submit
    document.addEventListener( 'wpcf7mailfailed', function( event ) {
        $(event.srcElement).find('[type=submit]').prop("disabled",false);
        $('.nhm-input-label .wpcf7-not-valid').each(function(index, el) {
            $(el).parents('.nhm-input-label').addClass('nhm-form-error')
        });
    }, false );



    //Remove carregando
    document.addEventListener( 'wpcf7submit', function( event ) {
        $(event.srcElement).find('form.wpcf7-form').removeClass('loading');
    }, false );



    window.addEventListener('scroll', function(e) {
        if(!is_ie() && ($(window).innerWidth() > 767)){
            var position = window.scrollY || window.pageYOffset || document.body.scrollTop;
            var windowH = window.innerHeight;

        }
    });
    

    $('.nhm-input-label').each(function(index, el) {
        let input = $(el).find('.nhm-input');
        let maxlength = $(el).find('.input-maxlength');
        input.focus(function(event) {
            $(el).addClass('-focus');
        });
        input.focusout(function(event) {
            $(el).removeClass('-focus');
        });

        if(maxlength.length > 0 && input.length > 0 && input.attr('maxlength') && input.attr('maxlength') > 0){
            input.keyup(function(event) {
                maxlength.html(input.val().length+'/'+input.attr('maxlength'));
            });
            input.keyup();
        }

    });





    $('[custom-modal-id]').click(function(event) {
        let el = this;
        if($('#'+$(el).attr('custom-modal-id')).length > 0){
            setTimeout(function(){
                $('body').addClass('custom-modal-active');
                $('body').addClass('no-scroll');
                $('#'+$(el).attr('custom-modal-id')).addClass('active');
            },300);
        }
    });

    


    


    $('.nhm-custom-modal-bg, .nhm-custom-modal-close, .custom-modal-close-modal').click(function(event) {
        setTimeout(function(){
            $('body').removeClass('custom-modal-active');
            $('body').removeClass('no-scroll');
        },300);
        $('.nhm-custom-modal').removeClass('active');
    });



    if($('.nhm-cookie-alert').length > 0){

        var nhm_advogados_cookie_alert = $('.nhm-cookie-alert')[0];
        var wp_nhm_advogados_cookie = readCookie('wp_nhm_advogados_cookie');
        if(wp_nhm_advogados_cookie && wp_nhm_advogados_cookie == 'true'){

        }else{
            $(nhm_advogados_cookie_alert).addClass('active');
            
            $(nhm_advogados_cookie_alert).find('.nhm-cookie-alert-accept').click(function(event) {
                createCookie('wp_nhm_advogados_cookie', 'true', 365);
                $(nhm_advogados_cookie_alert).removeClass('active');
            });

            $(nhm_advogados_cookie_alert).find('.hide-cookie-alert').click(function(event) {
                $(nhm_advogados_cookie_alert).removeClass('active');
            });

        }
    }



    $('.nhm-gallery-container').each(function(index, el) {
        let container = $(el);

        container.lightGallery({
            selector: '.gallery-item',
            download: false,
            addClass: 'gl-work-gallery-item',
            thumbnail: true,
        });
    });


    $('.nhm-tabs-container').each(function(index, el) {
        let header = $(el).find('.nhm-tabs-header');
        let body = $(el).find('.nhm-tabs-body');
        let btns = $(header).find('.item');
        let header_bg = $(header).find('.tabs-header-bg');
        let itens = $(body).find('.item');

        btns.click(function(event) {
            btns.removeClass('active');
            $(this).addClass('active');

            header_bg.css({
                            'width':this.offsetWidth,
                            'height':this.offsetHeight,
                            'top':this.offsetTop,
                            'left':this.offsetLeft
                        });

            itens.removeClass('active');
            $(body).find($(this).data('tab-id')).addClass('active');
        });

        if($(header).find('.item.active').length > 0){
            $(header).find('.item.active').click();
        }else if(btns.length > 0) {
            $(btns[0]).click();
        }

        setTimeout(function(){
            if($(header).find('.item.active').length > 0){
                $(header).find('.item.active').click();
            }else if(btns.length > 0) {
                $(btns[0]).click();
            }
        }, 400);

        window.addEventListener('resize', function(event){
            if($(header).find('.item.active').length > 0){
                $(header).find('.item.active').click();
            }else if(btns.length > 0) {
                $(btns[0]).click();
            }
        });

        setInterval(function(){
            let current_tab_btn = $(header).find('.item.active')[0];
            if(current_tab_btn){
                header_bg.css({
                                'width':current_tab_btn.offsetWidth,
                                'height':current_tab_btn.offsetHeight,
                                'top':current_tab_btn.offsetTop,
                                'left':current_tab_btn.offsetLeft
                            });
            }
        },500);
    });

    $('.nhm-header-search-open').click(function(event) {
        $('.nhm-header-search').addClass('-active');
    });
    $('.nhm-header-search-close').click(function(event) {
        $('.nhm-header-search').removeClass('-active');
    });


    $('.nhm-faq-container').each(function(index, el) {
        let search = $(el).find('.nhm-faq-search-input');
        let list = $(el).find('.nhm-faq-list');
        let items = $(list).find('.faq-item');

        search.keyup(function(event) {
            let val = this.value;
            items.removeClass('-open');
            items.each( function(i, e) {
                if(val == ''){
                    items.removeClass('-hidde');
                }else{
                    if($(e).find('.item-header .title').text().toUpperCase().indexOf(val.toUpperCase()) !== -1){
                        $(e).removeClass('-hidde');
                    }else{
                        $(e).addClass('-hidde');
                    }
                }

            });
        });
        search.change(function(event) {
            let val = this.value;
            items.removeClass('-open');
            items.each( function(i, e) {
                if(val == ''){
                    items.removeClass('-hidde');
                }else{
                    if($(e).find('.item-header .title').text().toUpperCase().indexOf(val.toUpperCase()) !== -1){
                        $(e).removeClass('-hidde');
                    }else{
                        $(e).addClass('-hidde');
                    }
                }

            });
        });

        items.each(function(i_index, item) {
            $(item).find('.item-header').click(function(event) {
                if($(list).hasClass('-only-one')){
                    let i_open = !$(item).hasClass('-open');
                    items.removeClass('-open');
                    if(i_open){
                        $(item).addClass('-open');
                    }
                }else{
                    $(item).toggleClass('-open');

                }
            });
        });
    });

    
}(window.jQuery, window, document));